import React from 'react';
import { Box, ListItemBase, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

const Delimiter = styled(Box)`
  width: ${({ theme }) => theme.spacings.spacing32};
`;

interface Props {
  items: ListItemBase[];
  hasOption?: boolean;
  style?: React.CSSProperties;
}

const TransactionsListHeader: React.FC<Props> = ({ items = [], hasOption = false, style }) => (
  <Box
    background="legend"
    round="container2Round"
    direction="row"
    pad={{ vertical: 'spacing8', right: 'spacing24', left: 'spacing16' }}
    margin={{ bottom: 'spacing8' }}
    style={style}
  >
    {items.map((item) => (
      <Box style={{ flex: item.flex }} key={item.key}>
        <Text size="small" weight="bold" color="textBody">
          {item.title}
        </Text>
      </Box>
    ))}
    {hasOption && <Delimiter />}
  </Box>
);

export default TransactionsListHeader;
